import { getAllAreas } from '@/stores/areas'
import { useSelector } from '@/stores/hooks'
import { useLoadAreas } from '../load/useLoadAreas'

export function useDataAllAreas({
	level = 4,
	disable,
}: { level?: number; disable?: boolean } = {}) {
	const load = useLoadAreas({ level, disable })
	const areas = useSelector(getAllAreas)
	return { ...load, areas }
}
